export enum OttopilotEventsWorkspaceCapabilityAccessOperation {
    create = "7a42276c-dc23-4527-b97f-bbaf72f8b72d",
    read = "c6ba637a-dde3-4858-b79f-8c0a53b33010",
    update = "9b673ce3-228b-4a43-b7f6-18d5f05fcff6",
    delete = "a6c30c94-afa2-4402-ab3f-1c7689ffa63b",
}
